import {
  Box,
  CircularProgress,
  CircularProgressProps,
  useTheme,
} from '@mui/material'

export function MuiCircularLoading({ ...props }: CircularProgressProps) {
  const theme = useTheme()
  return (
    <Box sx={{ minWidth: 'fit-content', display: 'flex', marginLeft: '10px' }}>
      <CircularProgress
        {...props}
        sx={{ ...props.sx, color: props.color || theme.palette.neutral900 }}
      />
    </Box>
  )
}
